import { useEffect, useState } from "react";
import { getSetting } from "../../services/settings.api";

// Doc 0446: "simple" es la vista tipo WhatsApp; "classic" la de siempre.
// Es un ajuste de la EMPRESA (Configuración › Apariencia, Settings.uiLayoutMode),
// igual que el tema: no hay elección por usuario.
const CHANGE_EVENT = "watoolx-ui-mode-change";
const LEGACY_USER_KEY = "watoolx_ui_mode";
export const COMPANY_UI_MODE_KEY = "uiLayoutMode";
export const UI_MODES = ["classic", "simple"];

// La caché vale para UNA empresa y solo guarda respuestas buenas. Antes valía para toda la
// pestaña y guardaba también los fallos: si la app arrancaba con la sesión caducada, el layout
// pedía el ajuste sin sesión, el fallo quedaba como «classic» y, tras iniciar sesión, se
// reutilizaba hasta recargar (QA 2026-10-27). Igual al cambiar a una cuenta de otra empresa.
let companyMode = null;
let companyRequest = null;
let cachedFor = null;

const notify = () => window.dispatchEvent(new Event(CHANGE_EVENT));

const currentCompany = () => {
  try {
    return localStorage.getItem("companyId") || null;
  } catch {
    return null;
  }
};

export function readUiMode() {
  return cachedFor === currentCompany() && companyMode ? companyMode : "classic";
}

function loadCompanyMode() {
  const company = currentCompany();
  if (!company) return Promise.resolve();
  if (cachedFor === company && companyRequest) return companyRequest;
  try {
    localStorage.removeItem(LEGACY_USER_KEY);
  } catch {
    /* noop */
  }
  cachedFor = company;
  companyMode = null;
  companyRequest = getSetting(COMPANY_UI_MODE_KEY)
    .then(({ data }) => {
      companyMode = UI_MODES.includes(data?.value) ? data.value : "classic";
    })
    .catch((err) => {
      // Una clave inexistente responde 404: es «classic» de verdad y se recuerda. Cualquier
      // otro fallo (sesión aún no lista, red) NO se recuerda: el próximo montaje lo reintenta.
      if (err?.response?.status === 404) companyMode = "classic";
      else companyRequest = null;
    })
    .finally(notify);
  return companyRequest;
}

/** Tras guardar en Apariencia: aplicarlo sin recargar. */
export function setCompanyUiModeCache(mode) {
  cachedFor = currentCompany();
  companyMode = UI_MODES.includes(mode) ? mode : "classic";
  companyRequest = Promise.resolve();
  notify();
}

export default function useUiMode() {
  const [mode, setMode] = useState(readUiMode);

  useEffect(() => {
    const sync = () => setMode(readUiMode());
    window.addEventListener(CHANGE_EVENT, sync);
    loadCompanyMode();
    sync();
    return () => window.removeEventListener(CHANGE_EVENT, sync);
  }, []);

  return { mode, isSimple: mode === "simple" };
}
